<template>
    <v-dialog v-model="dialog" persistent max-width="500px">
        <form @submit.prevent="onSubmit">
            <v-card>
                <v-card-title>
                    <span class="headline">Регистрация</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 sm6>
                                <v-text-field label="Имя" required></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field label="Фамилия" hint="example of helper text only on focus"></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field label="E-mail" type="email" required></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field label="Телефон" type="text" required></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field label="Пароль" type="password" required></v-text-field>
                            </v-flex>

                            <v-flex xs12>Платежные данные</v-flex>

                            <v-flex xs12>
                                <v-text-field label="Номер банковской карты" required></v-text-field>
                            </v-flex>
                            <v-flex xs12>Действительна до</v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field label="(месяц)" required></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field label="(год)" required></v-text-field>
                            </v-flex>

                        </v-layout>
                    </v-container>
                    <small><span style="color: red;opacity: .9;font-style: italic;">*Обязательное поле. Вводимые Вами данные не могут являться персональными!</span></small>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="dialog = false">Отмена</v-btn>
                    <v-btn type="submit" color="blue darken-1" flat>Зарегистрироваться</v-btn>
                </v-card-actions>
            </v-card>
        </form>
    </v-dialog>
</template>

<script>
    export default {
        methods: {
            open () {
                this.dialog = true
            },
            close () {
                this.dialog = false
            },
            onSubmit () {
                this.close()
                this.$emit('success')
            }
        },
        data: () => ({
            dialog: false
        })
    }
</script>
